import * as React from 'react';
import type { SVGProps } from 'react';
const SvgOrganization = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="currentColor"
    viewBox="0 0 17 16"
    {...props}
  >
    <path d="M10.714 0a3.215 3.215 0 0 1 2.263 5.496 6.1 6.1 0 0 1 1.85 1.33c1.014 1.06 1.673 2.48 1.673 3.889a.75.75 0 0 1-1.5 0c0-.957-.46-2.02-1.256-2.852-.79-.826-1.854-1.363-2.994-1.363h-.752a3.62 3.62 0 0 1-1.763 2.913c2.568.682 4.531 2.748 4.532 5.337a.75.75 0 0 1-1.5 0c0-2.148-2.074-4.078-4.883-4.078S1.5 12.602 1.5 14.75a.75.75 0 0 1-1.5 0c0-2.59 1.963-4.655 4.531-5.337A3.621 3.621 0 0 1 7.52 2.861 3.214 3.214 0 0 1 10.714 0m-4.33 4.179a2.122 2.122 0 1 0 1.83 1.052 3 3 0 0 1-.22-.31 2.12 2.12 0 0 0-1.61-.742m4.33-2.679a1.714 1.714 0 0 0-1.501 2.542q.12.15.225.314c.314.35.769.573 1.276.573a1.715 1.715 0 0 0 0-3.429" />
  </svg>
);
export default SvgOrganization;
